import type { FormElement, TableProperties } from '../model/form.types';

function isMatch(el: FormElement, excludeId?: string): boolean {
  if (el.type !== 'INDEXER_TITLE') return false;
  return excludeId === undefined || el.id !== excludeId;
}

function tableCellHasIndexerTitle(table: FormElement, excludeId?: string): boolean {
  const cells = (table.properties as TableProperties | undefined)?.cells ?? [];
  for (const row of cells) {
    for (const cell of row) {
      if (cell.content && isMatch(cell.content, excludeId)) return true;
    }
  }
  return false;
}

export function hasIndexerTitleElement(
  elements: ReadonlyArray<FormElement>,
  excludeId?: string,
): boolean {
  for (const el of elements) {
    if (isMatch(el, excludeId)) return true;
    if (el.type === 'TABLE' && tableCellHasIndexerTitle(el, excludeId)) return true;
  }
  return false;
}
